import { combineReducers } from "@reduxjs/toolkit";
import pagination from "./paginationSlice";

const reducer = combineReducers({
  pagination,
});

export default reducer;
